import { forwardRef } from 'react';

export const ApartmentIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.52728 37.7236C1.52728 37.4073 1.7837 37.1509 2.10001 37.1509H40.2818C40.5981 37.1509 40.8546 37.4073 40.8546 37.7236C40.8546 38.0399 40.5981 38.2963 40.2818 38.2963H2.10001C1.7837 38.2963 1.52728 38.0399 1.52728 37.7236Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.26923 7.02536C5.26923 6.70906 5.52564 6.45264 5.84195 6.45264H35.9674C36.2837 6.45264 36.5401 6.70906 36.5401 7.02536V34.8981C36.5401 35.2144 36.2837 35.4708 35.9674 35.4708H5.84195C5.52564 35.4708 5.26923 35.2144 5.26923 34.8981V7.02536ZM6.41468 7.59809V34.3254H35.3947V7.59809H6.41468Z"
        />
        <path d="M12.1419 10.1182H8.51468V15.12H12.1419V10.1182Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.94196 10.1181C7.94196 9.80183 8.19837 9.54541 8.51468 9.54541H12.142C12.4583 9.54541 12.7147 9.80183 12.7147 10.1181V15.12C12.7147 15.4363 12.4583 15.6927 12.142 15.6927H8.51468C8.19837 15.6927 7.94196 15.4363 7.94196 15.12V10.1181ZM9.08741 10.6909V14.5472H11.5692V10.6909H9.08741Z"
        />
        <path d="M19.1293 10.1182H15.5021V15.12H19.1293V10.1182Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9294 10.1181C14.9294 9.80183 15.1858 9.54541 15.5021 9.54541H19.1294C19.4457 9.54541 19.7021 9.80183 19.7021 10.1181V15.12C19.7021 15.4363 19.4457 15.6927 19.1294 15.6927H15.5021C15.1858 15.6927 14.9294 15.4363 14.9294 15.12V10.1181ZM16.0748 10.6909V14.5472H18.5566V10.6909H16.0748Z"
        />
        <path d="M26.1167 10.1182H22.4895V15.12H26.1167V10.1182Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9167 10.1181C21.9167 9.80183 22.1732 9.54541 22.4895 9.54541H26.1167C26.4331 9.54541 26.6895 9.80183 26.6895 10.1181V15.12C26.6895 15.4363 26.4331 15.6927 26.1167 15.6927H22.4895C22.1732 15.6927 21.9167 15.4363 21.9167 15.12V10.1181ZM23.0622 10.6909V14.5472H25.544V10.6909H23.0622Z"
        />
        <path d="M33.1035 10.1182H29.4763V15.12H33.1035V10.1182Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.9035 10.1181C28.9035 9.80183 29.16 9.54541 29.4763 9.54541H33.1035C33.4198 9.54541 33.6763 9.80183 33.6763 10.1181V15.12C33.6763 15.4363 33.4198 15.6927 33.1035 15.6927H29.4763C29.16 15.6927 28.9035 15.4363 28.9035 15.12V10.1181ZM30.049 10.6909V14.5472H32.5308V10.6909H30.049Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.94196 17.7927C7.94196 17.4764 8.19837 17.22 8.51468 17.22H12.142C12.4583 17.22 12.7147 17.4764 12.7147 17.7927V22.7945C12.7147 23.1108 12.4583 23.3672 12.142 23.3672H8.51468C8.19837 23.3672 7.94196 23.1108 7.94196 22.7945V17.7927ZM9.08741 18.3654V22.2218H11.5692V18.3654H9.08741Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9294 17.7927C14.9294 17.4764 15.1858 17.22 15.5021 17.22H19.1294C19.4457 17.22 19.7021 17.4764 19.7021 17.7927V22.7945C19.7021 23.1108 19.4457 23.3672 19.1294 23.3672H15.5021C15.1858 23.3672 14.9294 23.1108 14.9294 22.7945V17.7927ZM16.0748 18.3654V22.2218H18.5566V18.3654H16.0748Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9167 17.7927C21.9167 17.4764 22.1732 17.22 22.4895 17.22H26.1167C26.4331 17.22 26.6895 17.4764 26.6895 17.7927V22.7945C26.6895 23.1108 26.4331 23.3672 26.1167 23.3672H22.4895C22.1732 23.3672 21.9167 23.1108 21.9167 22.7945V17.7927ZM23.0622 18.3654V22.2218H25.544V18.3654H23.0622Z"
        />
        <path d="M33.1035 17.7927H29.4763V22.7945H33.1035V17.7927Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.9035 17.7927C28.9035 17.4764 29.16 17.22 29.4763 17.22H33.1035C33.4198 17.22 33.6763 17.4764 33.6763 17.7927V22.7945C33.6763 23.1108 33.4198 23.3672 33.1035 23.3672H29.4763C29.16 23.3672 28.9035 23.1108 28.9035 22.7945V17.7927ZM30.049 18.3654V22.2218H32.5308V18.3654H30.049Z"
        />
        <path d="M12.1419 25.5054H8.51468V30.889H12.1419V25.5054Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.94196 25.5053C7.94196 25.189 8.19837 24.9326 8.51468 24.9326H12.142C12.4583 24.9326 12.7147 25.189 12.7147 25.5053V30.889C12.7147 31.2053 12.4583 31.4617 12.142 31.4617H8.51468C8.19837 31.4617 7.94196 31.2053 7.94196 30.889V25.5053ZM9.08741 26.0781V30.3163H11.5692V26.0781H9.08741Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9294 25.5053C14.9294 25.189 15.1858 24.9326 15.5021 24.9326H19.1294C19.4457 24.9326 19.7021 25.189 19.7021 25.5053V34.8217C19.7021 35.138 19.4457 35.3944 19.1294 35.3944H15.5021C15.1858 35.3944 14.9294 35.138 14.9294 34.8217V25.5053ZM16.0748 26.0781V34.249H18.5566V26.0781H16.0748Z"
        />
        <path d="M26.1167 25.5054H22.4895V30.889H26.1167V25.5054Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9167 25.5053C21.9167 25.189 22.1732 24.9326 22.4895 24.9326H26.1167C26.4331 24.9326 26.6895 25.189 26.6895 25.5053V30.889C26.6895 31.2053 26.4331 31.4617 26.1167 31.4617H22.4895C22.1732 31.4617 21.9167 31.2053 21.9167 30.889V25.5053ZM23.0622 26.0781V30.3163H25.544V26.0781H23.0622Z"
        />
        <path d="M33.1035 25.5054H29.4763V30.889H33.1035V25.5054Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.9035 25.5053C28.9035 25.189 29.16 24.9326 29.4763 24.9326H33.1035C33.4198 24.9326 33.6763 25.189 33.6763 25.5053V30.889C33.6763 31.2053 33.4198 31.4617 33.1035 31.4617H29.4763C29.16 31.4617 28.9035 31.2053 28.9035 30.889V25.5053ZM30.049 26.0781V30.3163H32.5308V26.0781H30.049Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.26923 5.15451C5.26923 4.83821 5.52564 4.58179 5.84195 4.58179H35.9674C36.2837 4.58179 36.5401 4.83821 36.5401 5.15451V7.02542C36.5401 7.34173 36.2837 7.59815 35.9674 7.59815H5.84195C5.52564 7.59815 5.26923 7.34173 5.26923 7.02542V5.15451ZM6.41468 5.72724V6.4527H35.3947V5.72724H6.41468Z"
        />
      </svg>
    );
  },
);
